import { defineMessages } from 'react-intl';

export default defineMessages({
  description: 'How do you want to repay?',

  withYourCurrentCollateral: 'With your current collateral',
  fromYourWalletBalance: 'From your wallet balance',
});
